module.exports = __webpack_public_path__ + "media/images/icon__search--rb-gray-4b1b7375079a47c6be6af0cad606fcee.png";